import { AS } from "../namespaces";
import { breakpoint } from "../../exports/breakpoint";
import { exists, remove } from "../../exports/cookie";
import { eventLoader } from "../../exports/event-loader";

/**
 *
 *
 *
 *
 */
export function track(cookieName: string, isDeleted: boolean): void {
  AS.RUM.sendCustomRequest("asset", {
    cookieName,
    isDeleted,
    breakpoint: breakpoint.getCurrentBreakpoint(),
    parentUrl: window.location.href,
  });
}

/**
 *
 *
 *
 */
export function run(): void {
  let cookieDomain: string | undefined;

  const hostnameArr = window.location.hostname.split(".");
  const hostnameCount = hostnameArr.length;

  /*                                                           */
  /*                                                     */
  if (hostnameCount > 2) {
    cookieDomain = `.${hostnameArr.slice(hostnameCount - 2, hostnameCount).join(".")}`;
  }

  document.cookie
    /*                     */
    .split(/;\s*/)
    /*                                     */
    .map((c) => c.split(/=\s*/) as [string, string | undefined])
    /*                                                  */
    .filter(([, value]) => value && value.length > 1024)
    /*                           */
    .forEach(([cookieName]) => {
      /*           */
      if (
        !!cookieDomain &&
        cookieDomain.split(".")[cookieDomain.split(".").length - 1].length < 2
      ) {
        cookieDomain = "";
      }
      /*               */

      if (cookieDomain) {
        remove(cookieName, { domain: cookieDomain });
      } else {
        remove(cookieName);
      }

      /*                  */
      AS.cookieCheck.track(cookieName, !exists(cookieName));
    });
}

/*                         */
const cookieCheck = {
  /**
 *
 *
 *
 *
 */
  track,
  /**
 *
 *
 *
 */
  run,
};

/*           */
export type AssetsCookieCheck = {
  /**
 *
 *
 */
  cookieCheck: typeof cookieCheck;
};

/*             */
AS.cookieCheck = { track, run };
eventLoader.onLoad(1000, run);
